var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("apexchart", {
    attrs: {
      type: _vm.chartOptions.type,
      options: _vm.chartOptions.chartOptions,
      series: _vm.chartOptions.series,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }